import React, { useContext } from 'react'
import { Text } from 'oio-react'
import PropTypes from 'prop-types'
import { useOrganization } from 'src/graphql/hooks'
import { InitiativeHierarchyContext } from 'src/libraries/contexts/InitiativeHierarchy'

const communityPrivacyOptions = {
   open: 'Open',
   exclusive: 'Private',
   secret: 'Secret'
}

const PrivacySelectorDescription = ({ privacy }) => {
   const { organization } = useOrganization()
   const { initiative } = useContext(InitiativeHierarchyContext)

   if (privacy === 'inherit') {
      return (
         <>
            {/* IF OPEN COMMUNITY */}
            {organization.privacy === 'open' && `Anyone from the Public and the ${organization.name} Community can see and ${initiative.joinVerb} this ${initiative.type.nameSingular}.`}
            {/* IF EXCLUSIVE COMMUNITY */}
            {organization.privacy === 'exclusive' && `${organization.name} Community members can see and ${initiative.joinVerb} this ${initiative.type.nameSingular}. Public users can see but not ${initiative.joinVerb} this ${initiative.type.nameSingular}.`}
            {/* IF SECRET COMMUNITY */}
            {organization.privacy === 'secret' && `Anyone from the ${organization.name} Community can see and ${initiative.joinVerb} this ${initiative.type.nameSingular}. It is not visible to the public.`}
            <br />
            <br />
            <Text size="2" color="#777">
               <b>Note:</b>
               {` With this privacy setting, the privacy of this ${initiative.type.nameSingular} will automatically match the privacy of the ${organization.name} Community (including if the Community's privacy is updated in the future).`}
               <br />
               <br />
               {' This Community\'s privacy is currently set to: '}
               <b style={{ color: '#222' }}>{communityPrivacyOptions[organization.privacy]}</b>
            </Text>
         </>
      )
   }

   if (privacy === 'private') {
      return `Only people that are invited can see and join this ${initiative.type.nameSingular}`
   }

   if (privacy === 'admin') {
      return `Visible to admins of this ${initiative.type.nameSingular} and the ${organization.name} Community`
   }

   if (privacy === 'draft') {
      return 'Visible only to me'
   }

   return `This ${initiative.type.nameSingular} currently has custom privacy settings.`
}

PrivacySelectorDescription.propTypes = {
   privacy: PropTypes.string.isRequired
}

export default PrivacySelectorDescription
